import { useEffect, useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import branch from 'branch-sdk';

import { initMixpanel } from '@core/analytics/mixpanel';

import AppProvider from './contexts/app';
import AppRoutes from './routes';

import '@core/analytics/sentry/instrument';

const App = () => {
  const isBranchInitiated = useRef(false);
  const isMixpanelInitiated = useRef(false);

  useEffect(() => {
    // Initialize Branch.io with better error handling for external site access
    if (!isBranchInitiated.current) {
      const branchKey = process.env.REACT_APP_BRANCH_KEY;

      if (branchKey) {
        branch.init(branchKey, () => {
          isBranchInitiated.current = true;
        });
      } else {
        isBranchInitiated.current = true;
      }
    }

    if (!isMixpanelInitiated.current) {
      const mixpanelToken = process.env.REACT_APP_PUBLIC_MIXPANEL_TOKEN;

      if (mixpanelToken && mixpanelToken.trim() !== '') {
        try {
          initMixpanel();
          isMixpanelInitiated.current = true;
        } catch (error) {
          isMixpanelInitiated.current = true;
        }
      } else {
        isMixpanelInitiated.current = true;
      }
    }
  }, []);

  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
};

export default App;
